<template>
  <div class="operation_box">
    <div class="operation_item">
      <el-dropdown split-button type="primary"
                   @click="editAccount"
                   @command="(command) => command()"
      >
        <i class="fa fa-pencil"></i>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item :command="editAccount">
            <i class="fa fa-pencil"></i>
            {{ $t("common.edit")}}
          </el-dropdown-item>
          <el-dropdown-item :command="disableAccount" v-if="canDisableAccount">
            <i class="fa fa-ban"></i>
            {{ $t("common.button.disable")}}
          </el-dropdown-item>
          <el-dropdown-item :command="enableAccount" v-if="canEnableAccount">
            <i class="fa fa-check-circle"></i>
            {{ $t("common.button.enable")}}
          </el-dropdown-item>
          <el-dropdown-item :command="deleteAccount" v-if="canDeleteAccount">
            <i class="fa fa-trash"></i>
            {{ $t("common.button.delete")}}
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
import {enumDef} from "@/common/enumDefs";

export default {
  computed: {
    canDisableAccount() {
      return !this.params.data.isMainAccount && !this.canDeleteAccount
          && this.params.data.status !== enumDef.accountStatus.ManuallyDisabled;
    },
    canEnableAccount() {
      return this.params.data.status === enumDef.accountStatus.ManuallyDisabled;
    },
    canDeleteAccount() {
      return this.params.data.status === enumDef.accountStatus.Created;
    },
  },
  methods: {
    editAccount() {
      this.params.editAccount(this.params.data);
    },
    disableAccount() {
      this.params.disableAccount(this.params.data);
    },
    enableAccount() {
      this.params.enableAccount(this.params.data);
    },
    deleteAccount() {
      this.params.deleteAccount(this.params.data);
    }
  }
}
</script>



